<template lang="pug">
    div.c-form
        div.swithBlock
            div {{ $t('profile.reminders.pushNotificationLabel') }}

            div.ml-2
                // Switch (tooggle activate/deactivate push notifications)
                v-switch.c-switch(
                    :label="model.sendPush ? 'Yes' : 'No'"
                    v-model="model.sendPush"
                    :disabled="isLoading"
                    color="action"
                    hide-details
                )

        div.swithBlock.mt-3
            div {{ $t('profile.reminders.sendEmailLabel') }}

            div.ml-2
                // Switch (tooggle activate/deactivate push notifications)
                v-switch.c-switch(
                    :label="model.sendEmail ? 'Yes' : 'No'"
                    v-model="model.sendEmail"
                    :disabled="isLoading"
                    color="action"
                    hide-details
                )

        div.pickerBlock.mt-3
            div.bold {{ $t('profile.reminders.datePickerLabel') }}
            div.mt-2
                time-picker(
                    :label="$t('fields.sendTime')"
                    :predefinedTime="startTime"
                    :timePickerCallback="startTimeCallback"
                    icon="alarm"
                )
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapGetters } from 'vuex';
    import TimePicker from '~components/Picker/TimePicker';
    import dayjs from 'dayjs';

    export default {
        components: {
            TimePicker
        },
        computed: {
            ...mapFields('reminders', {
                model: 'reminder'
            }),

            ...mapGetters('reminders', ['isLoading']),

            startTime() {
                if (this.model.remindAt) {
                    return dayjs(this.model.remindAt).format('HH:mm');
                }

                return dayjs()
                    .add(1, 'hour')
                    .format('HH:mm');
            }
        },
        methods: {
            startTimeCallback(time) {
                let remindAt;

                const currentTime = dayjs().format('YYYY-MM-DD HH:mm');
                const pickerTime = dayjs(
                    `${dayjs().format('YYYY-MM-DD')} ${time}`
                ).format('YYYY-MM-DD HH:mm');
                const diff = dayjs(pickerTime).isBefore(currentTime, 'minute');

                if (diff) {
                    remindAt = dayjs()
                        .add(1, 'day')
                        .format('YYYY-MM-DD');
                } else {
                    remindAt = dayjs().format('YYYY-MM-DD');
                }

                remindAt = dayjs(`${remindAt} ${time}`);

                this.model.remindAt = remindAt;
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .swithBlock
        display: flex
        align-items: center
        justify-content: flex-start

    .pickerBlock
        font-size: 15px
        font-weight: 700
        max-width: 300px
</style>
